import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Admin.css';

interface User {
    id: number;
    mobile: string;
    role: string;
    is_verified: number;
    is_blocked: number;
    created_at: string;
}

const AdminUsers: React.FC = () => {
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async (searchTerm?: string) => {
        try {
            const params = searchTerm ? { search: searchTerm } : {};
            const response = await axios.get('/api/admin/users', { params });
            setUsers(response.data.users);
        } catch (error) {
            console.error('Failed to fetch users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        fetchUsers(search);
    };

    const handleBlockUnblock = async (user: User) => {
        const action = user.is_blocked ? 'unblock' : 'block';
        if (!window.confirm(`Are you sure you want to ${action} this user?`)) return;

        try {
            await axios.post(`/api/admin/users/${user.id}/${action}`);
            // Refresh list or update local state
            setUsers(users.map(u =>
                u.id === user.id ? { ...u, is_blocked: user.is_blocked ? 0 : 1 } : u
            ));
            alert(`User ${action}ed successfully`);
        } catch (error) {
            console.error(`Failed to ${action} user:`, error);
            alert(`Failed to ${action} user`);
        }
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="loading">Loading...</div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container">
                <h1 className="page-title">👥 User Management</h1>

                <div className="filters">
                    <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px' }}>
                        <input
                            type="text"
                            placeholder="Search by mobile..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="form-control"
                            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }}
                        />
                        <button type="submit" className="btn btn-primary">Search</button>
                    </form>
                </div>

                <div className="table-container">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Mobile</th>
                                <th>Role</th>
                                <th>Verified</th>
                                <th>Status</th>
                                <th>Joined</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user) => (
                                <tr key={user.id}>
                                    <td>{user.id}</td>
                                    <td>{user.mobile}</td>
                                    <td><span className="status-badge">{user.role}</span></td>
                                    <td>{user.is_verified ? '✅' : '❌'}</td>
                                    <td>
                                        {user.is_blocked ? (
                                            <span className="status-badge status-expired">Blocked</span>
                                        ) : (
                                            <span className="status-badge status-active">Active</span>
                                        )}
                                    </td>
                                    <td>{new Date(user.created_at).toLocaleDateString()}</td>
                                    <td>
                                        <button
                                            className={`btn ${user.is_blocked ? 'btn-primary' : 'btn-danger'}`}
                                            style={{ padding: '5px 10px', fontSize: '0.8rem' }}
                                            onClick={() => handleBlockUnblock(user)}
                                        >
                                            {user.is_blocked ? 'Unblock' : 'Block'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default AdminUsers;
